import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getFiltersAPi, fetchSearchLocationAPI } from "../../API/API";

function* searchGetFiltersSaga() {
  try {
    const response = yield call(() => getFiltersAPi()); // API Backend
    yield put({ type: types.GET_FILTERS_SUCCESS, payload: response.data });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_FILTERS_FAILURE, error });
  }
}


export function* watchGetFiltersSaga() {
  yield takeEvery(types.GET_FILTERS_REQUESTED, searchGetFiltersSaga);
}
